import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  Col,
  Row,
  Card,
  Dropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  BsFunnelFill,
  BsSearch,
  BsArrowClockwise,
  BsThreeDotsVertical,
  BsCreditCard,
  BsEyeFill,
  BsPencilFill,
  BsChevronDown,
  BsChevronUp,
  BsX} from 'react-icons/bs'
import {
  LuGraduationCap} from 'react-icons/lu'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { Typeahead } from 'react-bootstrap-typeahead'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import Cookies from 'js-cookie'

const DataTable = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    const userLogged = Cookies.get('user')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        setUserRole(JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [showModal, setShowModal] = useState(false)
  const [courses, setCourses] = useState([])
  const [selectedSession, setSelectedSession] = useState('')
  const [selectedNewCourse, setSelectedNewCourse] = useState([])
  const [showCourseDropdown, setShowCourseDropdown] = useState(false)
  const [baseAmount, setBaseAmount] = useState('')
  const [loading, setLoading] = useState(false)
  const [allFees, setAllFees] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState('')
  const [selectedCourseOption, setSelectedCourseOption] = useState([])
  const [isCourseDisabled, setIsCourseDisabled] = useState(false)
  const [isFrequencyDisabled, setIsFrequencyDisabled] = useState(false)

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      console.log('All course:', res.data.data)
      setCourses(res.data.data)
      setAllCourses(res.data.data)
    })
  }, [])
  useEffect(() => {
    ApiEndpoints.getAllFees()
      .then((res) => {
        setAllFees(res.data.data)
        setData(res.data.data) // This is your filtered data
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  const [newFee, setNewFee] = useState({
    fee_name: '',
    amount: '',
    // course_id: '',
    fee_frequency: '',
    session: '',
    fee_name_custom: ''})

  // const isManualAmount = (feeName = newFee.fee_name) => {
  //   return ['registration', 'admission', 'others'].includes(
  //     feeName?.toLowerCase(),
  //   )
  // }

  const isManualAmount = () => {
  return ['others', 'registration', 'admission','exam_fees', 'transport'].includes(newFee.fee_name?.toLowerCase())
}

  const getSessionOptions = () => {
    const currentYear = new Date().getFullYear()
    const sessions = []

    for (let i = 0; i < 1; i++) {
      let session = `${currentYear + i}-${(currentYear + i + 1)
        .toString()
        .slice(-2)}`
      sessions.push(session)
    }
    return sessions
  }

  const handleCourseFieldChange = (e) => {
    const courseId = e.target.value
    setSelectedData((prev) => ({ ...prev, course: courseId }))
    handleSelect({ course: courseId })
    console.log('HANDLESELECT:', handleSelect)
  }

  const updateAmountFromCourse = (courseIds, frequency = newFee.fee_frequency) => {
    if (!courseIds.length) {
      setBaseAmount('')
      if (newFee.fee_name === 'course') {
        setNewFee((prev) => ({ ...prev, amount: '' }))
      }
      return
    }

    const primaryCourse = courses.find(
      (course) => course.id === courseIds[0] || course.id.toString() === courseIds[0]?.toString(),
    )
    if (!primaryCourse) return

    setBaseAmount(primaryCourse.fee)

    if (newFee.fee_name === 'course' && frequency) {
      const amount = calculateAmount(primaryCourse.fee, frequency, courseIds[0])
      setNewFee((prev) => ({
        ...prev,
        amount}))
    }
  }

  const handleCourseChange = (e) => {
    const selectedId = e.target.value
    const isChecked = e.target.checked
    const numericId = isNaN(Number(selectedId)) ? selectedId : Number(selectedId)
    const prevIds = Array.isArray(selectedNewCourse)
      ? selectedNewCourse
      : selectedNewCourse
        ? [selectedNewCourse]
        : []
    const updated = isChecked
      ? [...prevIds, numericId]
      : prevIds.filter((id) => id.toString() !== numericId.toString())

    setSelectedNewCourse(updated)
    updateAmountFromCourse(updated)
  }

  const handleSelectAllCourses = (e) => {
    if (e.target.checked) {
      const allIds = courses.map((course) => course.id)
      setSelectedNewCourse(allIds)
      updateAmountFromCourse(allIds)
    } else {
      setSelectedNewCourse([])
      updateAmountFromCourse([])
    }
  }

  const handleRemoveSelectedCourse = (courseId) => {
    const prevIds = Array.isArray(selectedNewCourse)
      ? selectedNewCourse
      : selectedNewCourse
        ? [selectedNewCourse]
        : []
    const updated = prevIds.filter((id) => id.toString() !== courseId.toString())
    setSelectedNewCourse(updated)
    updateAmountFromCourse(updated)
  }

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  const totalPages = Math.ceil(filteredData.length / itemsPerPage)

  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  const calculateAmount = (base, frequency, courseId = null) => {
    const numericBase = parseFloat(base)
    if (isNaN(numericBase)) return ''

    const selectedIds = Array.isArray(selectedNewCourse)
      ? selectedNewCourse
      : selectedNewCourse
        ? [selectedNewCourse]
        : []
    const targetId = courseId ?? selectedIds[0]
    const selectedCourse = courses.find(
      (course) =>
        course.id === targetId || course.id.toString() === targetId?.toString(),
    )
    const duration = selectedCourse?.duration

    if (frequency === 'monthly' && duration) {
      return (numericBase / duration).toFixed(2)
    }

    return numericBase.toFixed(2)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target

    if (name === 'fee_name') {
      const feeName = value.toLowerCase()

      // Reset all fee-related fields when fee_name is 'course'
      if (feeName === 'course') {
        setNewFee({
          fee_name: 'course',
          amount: '',
          fee_frequency: '',
          session: '',
          fee_name_custom: ''})
        setSelectedNewCourse([])
        setIsFrequencyDisabled(false)
        setIsCourseDisabled(false)
        return
      }

      const isAdmissionOrRegistration = ['admission', 'registration'].includes(
        feeName,
      )

          const isExamFees = feeName === 'exam_fees'

      // const shouldDisableCourse = feeName === 'others'

      setNewFee((prev) => ({
        ...prev,
        fee_name: value,
        fee_frequency: isAdmissionOrRegistration || isExamFees ? 'one-time' : '',
          amount: isExamFees ? '' : prev.amount
      }))

      setIsFrequencyDisabled(isAdmissionOrRegistration || isExamFees)
      // setIsCourseDisabled(shouldDisableCourse)
      setSelectedNewCourse([])
      return
    }

    // Block fee_frequency changes if disabled
    if (name === 'fee_frequency' && isFrequencyDisabled) return

    if (name === 'amount' && isManualAmount()) {
      setNewFee((prev) => ({
        ...prev,
        amount: value}))
      return
    }

    // Update amount automatically based on frequency and course
    let updatedAmount = newFee.amount
    let updatedFrequency =
      name === 'fee_frequency' ? value : newFee.fee_frequency

    if (!isManualAmount()) {
      const selectedIds = Array.isArray(selectedNewCourse)
        ? selectedNewCourse
        : selectedNewCourse
          ? [selectedNewCourse]
          : []
      const selectedCourse = courses.find(
        (course) =>
          course.id === selectedIds[0] ||
          course.id.toString() === selectedIds[0]?.toString(),
      )
      const duration = selectedCourse?.duration || 1
      const numericBase = parseFloat(baseAmount)

      if (!isNaN(numericBase)) {
        updatedAmount =
          updatedFrequency === 'monthly'
            ? (numericBase / duration).toFixed(2)
            : numericBase.toFixed(2)
      }
    }

    setNewFee((prev) => ({
      ...prev,
      [name]: value,
      amount: updatedAmount}))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      const selectedIds = Array.isArray(selectedNewCourse)
        ? selectedNewCourse
        : selectedNewCourse
          ? [selectedNewCourse]
          : []

      if (!selectedIds.length) {
        toast.error('Please select at least one course.')
        return
      }

      setLoading(true)
      let feeName = newFee.fee_name

      if (feeName === 'others') {
        feeName = newFee.fee_name_custom?.trim().toLowerCase() || 'others'
      }

      const { fee_name_custom, ...cleanFee } = newFee
      const feeData = {
        ...cleanFee,
        // single course => scalar id; multiple => array of ids
        object_id: selectedIds.length === 1 ? selectedIds[0] : selectedIds,
        fee_name: feeName}

      const response = await ApiEndpoints.addFee(feeData)
      toast.success(response.data.message)

      // Reset form
      setNewFee({
        fee_name: '',
        amount: '',
        fee_frequency: '',
        session: '',
        fee_name_custom: ''})
      setSelectedNewCourse([])
      setShowCourseDropdown(false)
      setIsFrequencyDisabled(false)
      setIsCourseDisabled(false)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.message || 'Something went wrong.')
    } finally {
      setLoading(false)
    }
  }

  const [allCourses, setAllCourses] = useState([])

  const [selectedData, setSelectedData] = useState({ course: '' })

  const handleSelect = (selectedValues) => {
    setSelectedData(selectedValues)
    console.log('SETSELECTEDDATA:', selectedValues)
    fetchFilteredData(selectedValues)
  }
  const fetchFilteredData = (selectedValues) => {
    const { course } = selectedValues
    let updatedData = allFees
    if (course) {
      updatedData = updatedData.filter(
        (item) => item.object_id?.toString() === course.toString(),
      )
    }
    setData(updatedData)
  }

  useEffect(() => {
    // fetchFilteredData(selectedData)
    fetchFilteredData({ course: selectedCourseId })
  }, [])
  useEffect(() => {
    if (selectedCourseId && courses.length > 0) {
      const selected = courses.find((c) => c.id === Number(selectedCourseId))
      if (selected) {
        setSelectedCourseOption([selected])
      }
    }
  }, [courses, selectedCourseId])

  const handleRefresh = async () => {
    try {
      setLoading(true)
      const response = await ApiEndpoints.getAllFees()
      setAllFees(response.data.data)
      setData(response.data.data)
      setSelectedCourseId('')
      setSelectedCourseOption([])
    } catch (error) {
      toast.error('Failed to refresh data.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
          
          /* Fix Typeahead dropdown visibility - ensure it appears above filter card */
          .rbt-menu {
            z-index: 1051 !important;
            max-height: 300px !important;
            overflow-y: auto !important;
            position: absolute !important;
            width: 100% !important;
            background-color: #ffffff !important;
            border: 1px solid #D1D3D4 !important;
            border-radius: 8px !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
            margin-top: 4px !important;
          }
          
          .rbt-input-wrapper {
            position: relative !important;
            z-index: 1 !important;
          }
          
          .rbt-input-main {
            border-radius: 8px !important;
            border: 1px solid #D1D3D4 !important;
            font-size: 14px !important;
            padding: 8px 12px !important;
            transition: all 0.2s ease !important;
            font-family: 'Inter', system-ui, sans-serif !important;
          }
          
          .rbt-input-main:focus {
            border-color: #223843 !important;
            outline: none !important;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
          }
          
          .rbt-menu .dropdown-item {
            padding: 10px 12px !important;
            font-size: 14px !important;
            font-family: 'Inter', system-ui, sans-serif !important;
            color: #111827 !important;
            cursor: pointer !important;
          }
          
          .rbt-menu .dropdown-item:hover,
          .rbt-menu .dropdown-item.active {
            background-color: #F3F4F6 !important;
            color: #111827 !important;
          }
          
          /* Ensure filter card container allows dropdown to overflow */
          .filter-card-container {
            overflow: visible !important;
            position: relative !important;
            z-index: 10 !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Fee Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Fee Structure
              </h3>
              {/* {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                <button
                  onClick={() => {
                    setShowModal(true);
                    setNewFee({
                      fee_name: '',
                      amount: '',
                      fee_frequency: '',
                      session: '',
                      fee_name_custom: ''});
                    setSelectedNewCourse([]);
                    setShowCourseDropdown(false);
                    setIsFrequencyDisabled(false);
                    setIsCourseDisabled(false);
                  }}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#223843',
                    border: 'none',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title="Add New Fee Structure"
                >
                  <BsCreditCard size={20} />
                </button>
              )} */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (     
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="100">100 per page</option>
                  <option value="200">200 per page</option>
                  <option value="300">300 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>

            {/* Add New — desktop (mobile below, match CreateAnnouncement.js) */}
            {(user?.user_type === 'admin' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("fees_collector")) && (
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={() => {
                  setShowModal(true);
                  setNewFee({
                    fee_name: '',
                    amount: '',
                    fee_frequency: '',
                    session: '',
                    fee_name_custom: ''});
                  setSelectedNewCourse([]);
                  setShowCourseDropdown(false);
                  setIsFrequencyDisabled(false);
                  setIsCourseDisabled(false);
                }}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Fee Structure"
              >
                <BsCreditCard size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Fee Structure
                </span>
              </button>
            )}
          </div>

          {(user?.user_type === 'admin' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("fees_collector")) && (
            <div className="d-md-none d-flex justify-content-end mb-4">
              <button
                type="button"
                onClick={() => {
                  setShowModal(true);
                  setNewFee({
                    fee_name: '',
                    amount: '',
                    fee_frequency: '',
                    session: '',
                    fee_name_custom: ''});
                  setSelectedNewCourse([]);
                  setShowCourseDropdown(false);
                  setIsFrequencyDisabled(false);
                  setIsCourseDisabled(false);
                }}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Fee Structure"
              >
                <BsCreditCard size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Fee Structure
                </span>
              </button>
            </div>
          )}

          {/* Modern Filter Section */}
          <div 
            className="filter-card-container"
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: showFilterCard ? 'visible' : 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0',
              position: 'relative',
              zIndex: showFilterCard ? 10 : 1}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'visible',
                  position: 'relative'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search & Filter Fee Structure
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find fee structures quickly with advanced filters
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                  <Row className="g-4 text-start">
                    {/* Filter by Course */}
                    <Col xs={12} md={6}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative'}}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'}}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Filter by Course
                          </label>
                        </div>
                        <div style={{ position: 'relative', zIndex: 1050 }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Course
                          </label>
                          <div style={{ position: 'relative', zIndex: 1050 }}>
                            <Typeahead
                              id="course-select"
                              labelKey="name"
                              onChange={(selected) => {
                                const course = selected[0]
                                if (course) {
                                  setSelectedCourseId(course.id)
                                  setSelectedCourseOption([course])
                                  handleSelect({ course: course.id })
                                } else {
                                  setSelectedCourseId('')
                                  setSelectedCourseOption([])
                                  handleSelect({ course: '' })
                                }
                              }}
                              options={courses}
                              placeholder="Select Course"
                              selected={selectedCourseOption}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    {/* Filter by Session */}
                    <Col xs={12} md={6}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4'}}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'}}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Filter by Session
                          </label>
                        </div>
                        <div style={{ position: 'relative' }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Session
                          </label>
                          <Form.Select
                            value={selectedSession}
                            onChange={(e) => setSelectedSession(e.target.value)}
                            style={{
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#223843'
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#D1D3D4'
                            }}
                          >
                            <option value="">Filter by Session</option>
                            {getSessionOptions().map((session, index) => (
                              <option key={index} value={session}>
                                {session}
                              </option>
                            ))}
                          </Form.Select>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>
      {/* <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white d-none d-md-table-header-group">
          <tr className=" rounded">
            <th>Fee Name</th>
            <th>Course Name</th>
            <th>Amount</th>
            <th>Fee Frequency</th>
            <th>Action</th>
          </tr>
        </Thead>
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <tr className="d-none d-md-table-row">
                    <td>
                      {item.fee_name
                        ? item.fee_name.charAt(0).toUpperCase() +
                          item.fee_name.slice(1)
                        : 'N/A'}
                    </td>
                    <td>
                      {' '}
                      {courses.find((course) => course.id === item.object_id)
                        ?.name || 'N/A'}
                    </td>{' '}
                    <td>₹ {item.amount}</td>
                    <td>
                      {item.fee_frequency
                        ? item.fee_frequency.charAt(0).toUpperCase() +
                          item.fee_frequency.slice(1)
                        : 'N/A'}
                    </td>
                    <td className="text-center">
                      <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                        <Button variant="info" size="sm">
                          <Eye />
                        </Button>

                      </div>
                    </td>
                  </tr>

                  <tr className="d-table-row d-md-none">
                    <td colSpan="5">
                      <div className="card-body">
                        <p className="d-flex justify-content-between d-flex algin-items-center">
                          <strong>Fee Name</strong>
                          <span className="justify-content-start d-flex align-items-center">
                            {item.fee_name?.charAt(0).toUpperCase() +
                              item.fee_name?.slice(1) || 'N/A'}
                          </span>
                        </p>
                        <p className="d-flex justify-content-between d-flex algin-items-center">
                          <strong>Course Name</strong>{' '}
                          {courses.find(
                            (course) => course.id === item.object_id,
                          )?.name || 'N/A'}
                        </p>
                        <p>
                          <strong>Amount</strong> ₹ {item.amount}
                        </p>
                        <p>
                          <strong>Fee Frequency</strong>{' '}
                          {item.fee_frequency?.charAt(0).toUpperCase() +
                            item.fee_frequency?.slice(1) || 'N/A'}
                        </p>
                        <div className="d-flex gap-2">
                          <Button variant="info" size="sm">
                            <Eye />
                          </Button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              )
            })
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </Table> */}

        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Fee Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Course Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Amount</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Fee Frequency</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#F3F4F6',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #D1D3D4'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#F3F4F6'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#F3F4F6'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {item.fee_name
                        ? item.fee_name.charAt(0).toUpperCase() +
                          item.fee_name.slice(1)
                        : 'N/A'}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {courses.find((course) => course.id === item.object_id)
                        ?.name || 'N/A'}
                    </Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>₹ {item.amount}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {item.fee_frequency
                        ? item.fee_frequency.charAt(0).toUpperCase() +
                          item.fee_frequency.slice(1)
                        : 'N/A'}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="4" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="fee structures"
        />
        </div>

      {/* Modal for Adding Fee */}
        <Modal
        size="lg"
        show={showModal}
        onHide={() => {
          setShowModal(false)
          setShowCourseDropdown(false)
        }}
        centered
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
          <Modal.Title className="text-white">Add Fee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3 text-start">
              <Form.Label>Fee Name</Form.Label>
              <Form.Select
                name="fee_name"
                value={newFee.fee_name}
                onChange={handleInputChange}
              >
                <option value="">Select Fee Name</option>
                <option value="registration">Registration</option>
                <option value="admission">Admission</option>
                <option value="course">Course</option>
                <option value="exam_fees">Exam Fee</option>
                <option value="transport">Transport</option>
                <option value="others">Other Fee</option>             
              </Form.Select>
            </Form.Group>

            {newFee.fee_name === 'others' && (
              <Form.Group className="mb-3 text-start">
                <Form.Label>Custom Fee Name</Form.Label>
                <Form.Control
                  type="text"
                  name="fee_name_custom"
                  placeholder="Enter fee name (e.g. Late fees)"
                  value={newFee.fee_name_custom}
                  onChange={handleInputChange}
                />
              </Form.Group>
            )}

            <Form.Group className="mb-3 text-start">
              <Form.Label>Course *</Form.Label>
              {Array.isArray(selectedNewCourse) && selectedNewCourse.length > 0 && (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px',
                    marginBottom: '8px'}}
                >
                  {selectedNewCourse.map((id) => {
                    const course = courses.find(
                      (item) =>
                        item.id === id || item.id.toString() === id.toString(),
                    )
                    if (!course) return null
                    return (
                      <span
                        key={id}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          backgroundColor: '#e9ecef',
                          border: '1px solid #ced4da',
                          borderRadius: '16px',
                          padding: '2px 6px 2px 10px',
                          fontSize: '13px',
                          color: '#212529'}}
                      >
                        {course.name}
                        <button
                          type="button"
                          aria-label={`Remove ${course.name}`}
                          onClick={() => handleRemoveSelectedCourse(id)}
                          disabled={isCourseDisabled}
                          style={{
                            border: 'none',
                            background: 'transparent',
                            padding: 0,
                            lineHeight: 1,
                            cursor: isCourseDisabled ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center'}}
                        >
                          <BsX size={16} />
                        </button>
                      </span>
                    )
                  })}
                </div>
              )}
              <button
                type="button"
                onClick={() =>
                  !isCourseDisabled && setShowCourseDropdown((prev) => !prev)
                }
                disabled={isCourseDisabled}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  border: '1px solid #ced4da',
                  borderRadius: '0.375rem',
                  padding: '8px 12px',
                  backgroundColor: isCourseDisabled ? '#e9ecef' : '#fff',
                  color: '#212529',
                  cursor: isCourseDisabled ? 'not-allowed' : 'pointer',
                  textAlign: 'left',
                  fontSize: '1rem',
                  lineHeight: '1.5'}}
              >
                <span style={{ color: selectedNewCourse?.length ? '#212529' : '#6c757d' }}>
                  {Array.isArray(selectedNewCourse) && selectedNewCourse.length > 0
                    ? `${selectedNewCourse.length} course${
                        selectedNewCourse.length > 1 ? 's' : ''
                      } selected`
                    : 'Select Course'}
                </span>
                {showCourseDropdown ? (
                  <BsChevronUp size={16} color="#6c757d" />
                ) : (
                  <BsChevronDown size={16} color="#6c757d" />
                )}
              </button>
              {showCourseDropdown && (
                <div
                  style={{
                    border: '1px solid #ced4da',
                    borderTop: 'none',
                    borderRadius: '0 0 0.375rem 0.375rem',
                    padding: '10px 12px',
                    backgroundColor: isCourseDisabled ? '#e9ecef' : '#fff',
                    maxHeight: '180px',
                    overflowY: 'auto',
                    opacity: isCourseDisabled ? 0.65 : 1,
                    pointerEvents: isCourseDisabled ? 'none' : 'auto'}}
                >
                  {courses.length === 0 ? (
                    <div style={{ color: '#6c757d' }}>No courses available</div>
                  ) : (
                    <>
                      <Form.Check
                        type="checkbox"
                        id="select-all-courses"
                        label={`Select All (${
                          Array.isArray(selectedNewCourse)
                            ? selectedNewCourse.length
                            : selectedNewCourse
                              ? 1
                              : 0
                        }/${courses.length})`}
                        checked={
                          courses.length > 0 &&
                          Array.isArray(selectedNewCourse) &&
                          selectedNewCourse.length === courses.length
                        }
                        onChange={handleSelectAllCourses}
                        className="mb-2 fw-semibold"
                      />
                      <hr className="my-2" />
                      {courses.map((course) => {
                        const selectedIds = Array.isArray(selectedNewCourse)
                          ? selectedNewCourse
                          : selectedNewCourse
                            ? [selectedNewCourse]
                            : []
                        return (
                          <Form.Check
                            key={course.id}
                            type="checkbox"
                            id={`fee-course-${course.id}`}
                            label={course.name}
                            value={course.id}
                            checked={selectedIds.some(
                              (id) => id.toString() === course.id.toString(),
                            )}
                            onChange={handleCourseChange}
                            className="mb-2"
                          />
                        )
                      })}
                    </>
                  )}
                </div>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Fee Frequency *</Form.Label>
              <Form.Select
                name="fee_frequency"
                value={newFee.fee_frequency}
                onChange={handleInputChange}
                required
                disabled={isFrequencyDisabled}
              >
                <option value="">Select</option>
                <option value="monthly">Monthly</option>
                <option value="one-time">One Time</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Amount *</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={newFee.amount}
                onChange={handleInputChange}
                disabled={!isManualAmount()}
                placeholder={
                  isManualAmount() ? 'Enter amount' : 'Auto-calculated'
                }
                required
              />
            </Form.Group>
            {/* <Form.Group className="mb-3">
              <Form.Label>Amount *</Form.Label>
              <Form.Control
                type="number"
                name="amount"
                value={newFee.amount}
                disabled
              />
            </Form.Group> */}
            <Form.Group className="mb-3">
              <Form.Label>Session</Form.Label>
              <Form.Select
                name="session"
                value={newFee.session || ''}
                onChange={handleInputChange}
              >
                <option value="">Select Session</option>
                {getSessionOptions().map((session, index) => (
                  <option key={index} value={session}>
                    {session}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowModal(false)
                  setShowCourseDropdown(false)
                }}
              >
                Close
              </Button>
              <Button variant="success" type="submit">
                Add Fee
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      </div>
    </>
  )
}

export default DataTable
